import * as types from '../mutation-types'
import { apiV2 } from '../api'

const customerV2 = {
  namespaced: true,

  state: {
    validationRequests: {}
  },

  mutations: {
    [types.CUSTOMER_VALIDATION_REQUESTS_FETCHED](state, payload) {
      state.validationRequests = payload
    }
  },

  actions:{
    getCustomerValidationRequests({commit}, params) {
      const customerId = params.customerId

      delete params.customerId

      const queryParams = {
        ...params,
        sort: "-created_at"
      }

      if (!queryParams.hasOwnProperty('page')) {
        queryParams.page = 1
      }

      return apiV2.getCustomerValidationRequests(customerId, queryParams)
        .then((response) => commit (types.CUSTOMER_VALIDATION_REQUESTS_FETCHED, response.data))
    }
  }
}
  
export default customerV2


// WEBPACK FOOTER //
// ./client/store/modules/customerV2.js